"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bew_localization_1 = require("@skype/bew-localization");
const config_1 = require("config");
const React = require("react");
const AriaContext_1 = require("src/ts/contexts/AriaContext");
const LoggerHelper_1 = require("../../helpers/LoggerHelper");
const HipObject_1 = require("./HipObject");
const rand = Math.round(Math.random() * 10000000);
class Captcha extends React.PureComponent {
    constructor(props) {
        super(props);
        this._onLoad = () => {
            this.props.onLoad();
            this._hipObject.setFocus();
        };
        this._setRef = (element) => {
            if (element) {
                const script = document.createElement('script');
                script.src = config_1.default.urls.api.captcha(bew_localization_1.localizer.getLocale(), LoggerHelper_1.logger.getSessionId(), rand.toString());
                script.async = true;
                script.defer = true;
                element.appendChild(script);
            }
        };
        this.state = {};
        HipObject_1.hipConfig.postLoad = this._onLoad;
        window.WLSPHIP0 = HipObject_1.hipConfig;
        this._hipObject = window.WLSPHIP0;
    }
    reloadHip() {
        this._hipObject.reloadHIP();
    }
    verify(callback) {
        this._hipObject.verify((solution, token, hipObject) => {
            hipObject.clientValidation();
            callback({
                solution,
                token,
                type: hipObject.type,
            }, this._hipObject.getError());
        }, this._hipObject);
    }
    render() {
        return React.createElement(React.Fragment, null,
            React.createElement(AriaContext_1.AriaContextConsumer, null, (ariaContext) => React.createElement("div", { id: 'captcha-container', className: 'captcha-container', ref: () => {
                    ariaContext.announce({ assertive: true, text: bew_localization_1.localizer.getString('Common.a11y_announce_captcha') });
                } },
                React.createElement("div", { id: 'captchaImage' }),
                React.createElement("div", { id: 'captchaScript', ref: this._setRef }),
                React.createElement("div", { id: 'captchaError', className: 'captcha__error' }))));
    }
}
exports.Captcha = Captcha;
